import React from "react";
import { Button } from "@mui/material";
import Alert from "@mui/material/Alert";
import CommonDialog from "../CommonDialog/CommonDialog";
import './UnsavedDialog.css';

const UnsavedDialog = ({
  open,
  onClose,
  cellName,
  handleSave,
  handleTabClose,
}) => {
  const handleSaveAndExit = () => {
    onClose();
    handleSave();
    handleTabClose();
  };

  const handleExitWithoutSave = () => {
    onClose();
    handleTabClose();
  };

  return (
    <CommonDialog open={open} onClose={onClose} title="Unsaved Changes">
      <Alert severity="warning" className="unsaved-alert">
        You have unsaved changes in <strong>{cellName}</strong>. What would you like to do?
      </Alert>
      <>
        <Button variant="contained" onClick={handleSaveAndExit} className="unsaved-dialog-button">
          Save and Exit
        </Button>
        <Button variant="contained" onClick={handleExitWithoutSave} className="unsaved-dialog-button">
          Exit without Save
        </Button>
      </>
    </CommonDialog>
  );
};

export default UnsavedDialog;
